import React, { Fragment, useState, useEffect } from 'react';
import clsx from 'clsx';
import config from '../../pages/config.json';
import axios from 'axios';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { Hidden, Drawer, Paper } from '@mui/material';
import { connect } from 'react-redux';
import { Formik } from 'formik';
import SidebarHeader from '../../layout-components/SidebarHeader';
import SidebarMenu from '../../layout-components/SidebarMenu';
import { getMenu } from './navItems';
import navItemsClientUsers from './navItemsClientUsers';
import navItemsUsers from './navItemsUsers';
import { setSidebarToggleMobile } from '../../reducers/ThemeOptions';
import Qblogo from '../../assets/images/quicbooks/qblogo.png';
import { Dialog, DialogActions, DialogContent, DialogTitle, Grid, MenuItem, TextField, Button } from '@mui/material';
import { faWindowClose, faAdd } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import PageTitle from '../../shared/components/PageTitle';
import TableContainer from '@mui/material/TableContainer';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
import { getQuickBookOnline } from '../../pages/api';

const Sidebar = props => {
  const {
    setSidebarToggleMobile,
    sidebarToggleMobile,
    sidebarFixed,

    sidebarShadow
  } = props;

  const navigate = useNavigate();
  const token = config.TOKEN;
  var [isQbActive, setIsQbActive] = React.useState();
  const [showPopup, setShowPopup] = useState(false);
  var [orgId, setOrgId] = useState(null);
  var [orgName, setOrgName] = useState(null);
  var [orgIdList, setOrgIdList] = useState([]);
  const errorMessage = () => toast("An error occured, try again later");

  const qbStatus = async () => {
    try {
      const res = await getQuickBookOnline();
      if (res.data.successCode === 0) {
        isQbActive = res.data.data
        setIsQbActive(isQbActive);
      } else {
        errorMessage();
      }
    } catch (error) {
      errorMessage();
    }
  }

  useEffect(() => {
    if (showPopup) {
      orgList();
    }
    if (userType === "SUPER_ADMIN") {
      orgName = localStorage.getItem('orgName');
      setOrgName(orgName);
    } else {
      setOrgName(userProfile?.orgName);
    }
    qbStatus()
    const timer = setInterval(
      () => qbStatus(),
      120 * 1000
    );
    return () => clearInterval(timer);
  }, [showPopup])

  const orgList = () => {
    const MOBILESURETY_URL = config.API_URL + "/api/Auth/org/List"
    const token = config.TOKEN
    axios.get(MOBILESURETY_URL, {
      headers: {
        'Authorization': `Basic ${token}`
      }
    })
      .then((res) => {
        if (res.data.successCode === 1) {
          orgIdList = res.data.data.filter((a) => a.isActive === true)
          setOrgIdList(orgIdList);
        } else {
          errorMessage();
        }
      })
  }

  const closeDrawer = () => setSidebarToggleMobile(!sidebarToggleMobile);
  let userProfile = localStorage.getItem("userProfile");
  userProfile = JSON.parse(userProfile);
  let userType = userProfile?.userType;

  const navItems = getMenu();

  const handleNavItems = () => {

    if (userType == "User") {
      return (
        navItemsUsers.map(list => (
          <SidebarMenu
            component="div"
            key={list.label}
            pages={list.content}
            title={list.label}
          />
        )
        ))
    } else if (userType == "ClientUser") {
      return (
        navItemsClientUsers.map(list => (
          <SidebarMenu
            component="div"
            key={list.label}
            pages={list.content}
            title={list.label}
          />))
      )
    }
    else {
      return (
        navItems.map(list => (
          <SidebarMenu
            component="div"
            key={list.label}
            pages={list.content}
            title={list.label}
          />))
      )
    }
  }

  const sidebarMenuContent = (

    <div>
      {handleNavItems()}
    </div>
  );

  return (
    <Fragment>
      <ToastContainer theme='dark' progressStyle={{ backgroundColor: "#F59300" }} />
      {showPopup && (
        <TableContainer>
          <Dialog open={showPopup} onClose={() => setShowPopup(false)} closeonescape="true" fullWidth={true} maxWidth="sm">
            <DialogTitle>
              <div className="text-right" onClick={() => setShowPopup(false)} style={{ cursor: "pointer" }}>
                <FontAwesomeIcon icon={faWindowClose} className="closeIcon" />
              </div>
            </DialogTitle>
            <PageTitle style={{ marginLeft: "25px" }}>Choose Organization you want to work</PageTitle>
            <DialogContent>
              <Formik
                enableReinitialize={true}
                initialValues={{ appOrgId: "" }}
                validate={(values) => {
                  const errors = {}

                  if (!values.appOrgId) {
                    errors.appOrgId = "Required!"
                  }
                  return errors;
                }}

                const handleMouseDownPwd={(event) => {
                  event.preventDefault();
                }}

                onSubmit={(values, { setSubmitting }) => {
                  const postData = {
                    orgId: values.appOrgId
                  }
                  console.log(postData);
                  orgId = localStorage.setItem('orgId', values.appOrgId);
                  setOrgId(orgId);
                  orgName = localStorage.setItem('orgName', orgIdList.find(org => org.appOrgId === values.appOrgId)?.name);
                  setOrgName(orgName);
                  setShowPopup(false);
                  setSubmitting(false);
                  window.location.reload();
                }}
              >
                {({
                  values,
                  errors,
                  touched,
                  handleChange,
                  handleBlur,
                  handleSubmit,
                  isSubmitting
                }) => (
                  <form onSubmit={handleSubmit}>
                    <Grid container spacing={4} className='d-flex justify-content-center'>
                      <Grid item xs={12} sm={12} md={12}>
                        <div style={{ display: "flex", width: "80%" }}>
                          <TextField
                            style={{ width: "90%" }}
                            id="appOrgId"
                            name="appOrgId"
                            className="filterDropdown"
                            select label="Select Org"
                            helperText=""
                            variant="standard"
                            value={values.appOrgId || ""}
                            onChange={handleChange}
                            onBlur={handleBlur}
                          >
                            {orgIdList.map(option => (
                              <MenuItem key={option.appOrgId} value={option.appOrgId}>
                                {option.name}
                              </MenuItem>
                            ))}
                          </TextField>
                          <FontAwesomeIcon icon={faAdd} className="closeIcon m-3"
                            style={{
                              borderRadius: "50%",
                              backgroundColor: "rgb(245, 147, 0)",
                              color: "white",
                              padding: "5px",
                              fontSize: "20px",
                              cursor: "pointer",
                            }}
                            onClick={() => navigate("/org/list", { state: { openPopup: true } })} />
                        </div>
                        <div className="errMsg" style={{ marginTop: "-5px" }}>{errors.appOrgId && touched.appOrgId && errors.appOrgId}</div>
                      </Grid>
                    </Grid>
                    <DialogActions>
                      <Grid container spacing={4}>
                        <Grid item xs={12} sm={12} md={12} className="text-right mt-4">
                          <Button type="button" variant="outlined" color="primary" className="noShadow cancelBtn" onClick={() => setShowPopup(false)}>
                            Cancel
                          </Button>&nbsp;&nbsp;
                          <Button type="submit" variant="contained" color="primary" className="noShadow addBtn" disabled={isSubmitting}>
                            Submit
                          </Button>
                        </Grid>
                      </Grid>
                    </DialogActions>
                  </form>
                )}
              </Formik>
            </DialogContent>
          </Dialog>
        </TableContainer>
      )}
      <Hidden lgUp>
        <Drawer
          anchor="left"
          open={sidebarToggleMobile}
          onClose={closeDrawer}
          variant="temporary"
          elevation={4}
          className="app-sidebar-wrapper-lg"
          style={{ display: 'flex', flexDirection: 'column', height: '100vh' }}
        >
          <SidebarHeader />
          <div
            className={clsx('app-sidebar-menu', sidebarFixed && 'sidebarFixed', {
              'sidebar-super-admin': userType === "SUPER_ADMIN"
            })}
            style={{ overflow: 'hidden', }}
          >
            <PerfectScrollbar>{sidebarMenuContent}</PerfectScrollbar>
          </div>
          {userType === "SUPER_ADMIN" ?
            <div style={{ bottom: 0, left: 0, width: "100%", textAlign: "center", padding: "4px", fontsize: "18px", fontWeight: 600, color: "#fff", background: "#F6931E", display: "flex", justifyContent: "space-around" }}>
              <div style={{ paddingTop: "5px" }}>{orgName}</div>
              <SwapHorizIcon style={{ fontSize: "28px", marginRight: "8px", cursor: "pointer" }} onClick={() => setShowPopup(true)} />
            </div> :
            <div className='qb-logo'>
              <div className='qb-status'>
                <img style={{ mixBlendMode: 'multiply', paddingLeft: '7px' }} src={Qblogo} width="140px"></img>
                {isQbActive != undefined && <span className={isQbActive == true ? "dotActive" : "dotInactive"}></span>}
              </div>
            </div>
          }
        </Drawer>
      </Hidden>

      <Hidden mdDown>
        <Paper
          className={clsx('app-sidebar-wrapper', {
            'app-sidebar-wrapper-fixed': sidebarFixed,
            'app-sidebar-wrapper-hidden': sidebarToggleMobile
          })}
          square
          elevation={sidebarShadow ? 11 : 3}
          style={{ display: 'flex', flexDirection: 'column', height: '100vh' }}
        >
          <SidebarHeader />
          <div
            className={clsx('app-sidebar-menu', sidebarFixed && 'sidebarFixed', {
              'sidebar-super-admin': userType === "SUPER_ADMIN"
            })}
            style={{ overflow: 'hidden', }}
          >
            <PerfectScrollbar options={{ wheelPropagation: false }}>
              {sidebarMenuContent}
            </PerfectScrollbar>
          </div>
          {userType === "SUPER_ADMIN" ? <div style={{ bottom: 0, left: 0, width: "100%", textAlign: "center", padding: "4px", fontsize: "18px", fontWeight: 600, color: "#fff", background: "#F6931E", display: "flex", justifyContent: "space-around" }}>
            <div style={{ paddingTop: "5px" }}>{orgName}</div>
            <SwapHorizIcon style={{ fontSize: "28px", marginRight: "8px", cursor: "pointer" }} onClick={() => setShowPopup(true)} />
          </div> :
            <div className='qb-logo'>
              <div className='qb-status'>
                <img style={{ mixBlendMode: 'multiply', paddingLeft: '7px' }} src={Qblogo} width="140px"></img>
                {isQbActive != undefined && <span className={isQbActive == true ? "dotActive" : "dotInactive"}></span>}
              </div>
            </div>
          }
        </Paper>
      </Hidden>
    </Fragment>
  );
};
const mapStateToProps = state => ({
  sidebarFixed: state.ThemeOptions.sidebarFixed,
  headerFixed: state.ThemeOptions.headerFixed,
  sidebarToggleMobile: state.ThemeOptions.sidebarToggleMobile
});

const mapDispatchToProps = dispatch => ({
  setSidebarToggleMobile: enable => dispatch(setSidebarToggleMobile(enable))
});

export default connect(mapStateToProps, mapDispatchToProps)(Sidebar);
